

import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg';
import shape1 from '../../../images/shapes/shape_line_2.svg';
import shape2 from '../../../images/shapes/shape_line_3.svg';
import shape3 from '../../../images/shapes/shape_line_4.svg';
import shape4 from '../../../images/shapes/shape_space_3.svg';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import TechnologySection from '../TechnologySection/TechnologySection';
import { useParams } from 'react-router-dom';

const FaqSection = (props) => {
    const [open, setOpen] = useState('1');
    const { slug } = useParams();
    
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    // Define content based on slug
    const getContentBySlug = () => {
        switch(slug) {
            case 'seo-services':
                return [
                    {
                        id: '1',
                        title: 'Website Audit',
                        content: 'We start with a complete SEO audit of your website to identify technical issues, performance gaps, and ranking opportunities. This includes analyzing site structure, speed, mobile-friendliness, and competitors.'
                    },
                    {
                        id: '2',
                        title: 'Keyword Strategy',
                        content: 'Our team performs in-depth keyword research to target the most relevant and profitable search terms. Based on this, we create a content roadmap that boosts visibility and aligns with your business goals.'
                    },
                    {
                        id: '3',
                        title: 'On-Page Optimization',
                        content: 'We optimize all website elements including meta tags, headings, internal linking, images, and URL structure. This ensures your pages are search-engine friendly and deliver a great user experience.'
                    },
                    {
                        id: '4',
                        title: 'Off-Page SEO',
                        content: 'To strengthen your authority, we build high-quality backlinks, manage local citations, and enhance your brand presence across digital platforms. This improves both credibility and search rankings.'
                    },
                    {
                        id: '5',
                        title: 'Performance Tracking',
                        content: 'SEO is an ongoing process. We use advanced analytics tools to track keyword rankings, traffic growth, and conversions. You\'ll receive regular reports with actionable insights for continuous improvement.'
                    }
                ];
            case 'smo-services':
                return [
                    {
                        id: '1',
                        title: 'Profile Optimization',
                        content: 'We develop and optimize business profiles on social networking sites to build consistency, branding, and trustworthiness.'
                    },
                    {
                        id: '2',
                        title: 'Content Creation',
                        content: 'As the Best SMO Company in Alwar, we create innovative and interesting posts, images, and videos that attract your target audience.'
                    },
                    {
                        id: '3',
                        title: 'Audience Engagement',
                        content: 'We emphasize relationship-building by engaging with queries, inviting interactions, and developing brand loyalty.'
                    },
                    {
                        id: '4',
                        title: 'Paid Campaigns & Promotions',
                        content: 'Our specialists implement highly targeted campaigns to achieve maximum reach and generate quality leads.'
                    },
                    {
                        id: '5',
                        title: 'Analytics & Reporting',
                        content: 'We monitor performance, interpret insights, and offer informative reports to track growth and ROI.'
                    }
                ];
            case 'app-development-services':
                return [
                    {
                        id: '1',
                        title: 'Requirement Analysis',
                        content: 'We start with a thorough know-how of your business needs and target audience. With the Best App Development Company in Alwar, we develop a plan that makes your app market-relevant.'
                    },
                    {
                        id: '2',
                        title: 'UI/UX Design',
                        content: 'We craft user-friendly and visually stimulating app interfaces that ensure flawless user experience. Our design-led process guarantees maximum interaction and happiness.'
                    },
                    {
                        id: '3',
                        title: 'Custom Development',
                        content: 'From iOS and Android to hybrid platforms, we offer comprehensive App Development Services in Alwar and India using the latest technologies and frameworks for secure and scalable apps.'
                    },
                    {
                        id: '4',
                        title: 'Testing & Quality Assurance',
                        content: 'We conduct thorough testing by our QA professionals to guarantee effortless execution, rapid performance, and flawless applications prior to launch.'
                    },
                    {
                        id: '5',
                        title: 'Deployment & Maintenance',
                        content: 'We provide app deployment to Play Store and App Store, then ongoing updates, security patches, and maintenance for reliability over time.'
                    }
                ];
            case 'graphic-design-services':
                return [
                    {
                        id: '1',
                        title: 'Understanding Your Brand',
                        content: 'We begin with getting to know your vision, values, and audience. As the Best Graphic Design Company in Alwar, we arrive with concepts that integrate your brand identity.'
                    },
                    {
                        id: '2',
                        title: 'Creative Concept & Design',
                        content: 'Furnished with creative ideas, our design team converts them into wonderful pictures. Innovation and creativity are our mantras, online and offline.'
                    },
                    {
                        id: '3',
                        title: 'Design Development',
                        content: 'We design top-notch graphics with precision, integrating the best color palette, typography, and layout to drive your message.'
                    },
                    {
                        id: '4',
                        title: 'Feedback & Improvements',
                        content: 'At every turn, we work alongside you to make changes until the final product looks just as you imagined.'
                    },
                    {
                        id: '5',
                        title: 'Delivery & Support',
                        content: 'We provide you with high-quality pre-designed templates and help put them on online and offline media.'
                    }
                ];
            case 'video-editing-services':
                return [
                    {
                        id: '1',
                        title: 'Understanding Your Needs',
                        content: 'We begin with developing an understanding of your vision, target group, and goals. As the Best Video Editing Company in Alwar, we curate editing plans that are project-oriented.'
                    },
                    {
                        id: '2',
                        title: 'Creative Editing & Storytelling',
                        content: 'We combine and mix visuals, sound, and effects to establish a fascinating story. Our editing focuses on flow, simplicity, and interest to produce optimum audience impact.'
                    },
                    {
                        id: '3',
                        title: 'Advanced Tools & Techniques',
                        content: 'Using the most up-to-date editing equipment and software, we produce videos of expert quality that look great on any device.'
                    },
                    {
                        id: '4',
                        title: 'Revisions & Refinements',
                        content: 'Since collaboration is what it\'s all about, we provide revisions and refinements to guarantee the final video looks however you want it.'
                    },
                    {
                        id: '5',
                        title: 'Delivery & Support',
                        content: 'We provide videos in the formats you ask for, ready to roll for social media publishing, web deployment, or broadcast, with ongoing support.'
                    }
                ];
            case 'ui-ux-development-services':
                return [
                    {
                        id: '1',
                        title: 'Research & Strategy',
                        content: 'We start with extensive research on your competitors, business objectives, and target audience. As Alwar\'s Best UI/UX Company, we craft solutions that meet your vision and user requirements.'
                    },
                    {
                        id: '2',
                        title: 'Wireframing & Prototyping',
                        content: 'We develop wireframes and prototypes that enable the visualization of the user experience. This ensures the design is functional, intuitive, and interesting prior to development.'
                    },
                    {
                        id: '3',
                        title: 'UI Design',
                        content: 'Our UI design team creates modern, responsive, and streamlined interfaces. We ensure that your design has a lasting effect by taking branding, colour psychology, and visual hierarchy into account.'
                    },
                    {
                        id: '4',
                        title: 'UX Development',
                        content: 'We craft smooth, user-friendly experiences through simplified navigation, interaction, and accessibility. Our UI/UX Services India are engineered to deliver high levels of engagement and satisfaction.'
                    },
                    {
                        id: '5',
                        title: 'Testing & Optimization',
                        content: 'We carry out usability testing before to launch in order to identify problems and optimise the design.'
                    }
                ];
            case 'custom-software-services':
                return [
                    {
                        id: '1',
                        title: 'Requirement Analysis & Planning',
                        content: 'We start by a comprehensive analysis of your business operations and objectives. As the Best Software Development Company in Alwar, we build a cost-effective development plan of long-term worth.'
                    },
                    {
                        id: '2',
                        title: 'UI/UX Design',
                        content: 'Our designers are committed to creating intuitive and user-friendly interfaces that will make your software very effective and simple to use.'
                    },
                    {
                        id: '3',
                        title: 'Custom Development',
                        content: 'We develop highly personalized software products with the newest technologies. From desktop to web applications, our Custom Software Development Services in India ensure reliability and performance.'
                    },
                    {
                        id: '4',
                        title: 'Testing & Quality Assurance',
                        content: 'Every solution is tested for performance, security, and scalability strictly. Our QA team will ensure your software runs perfectly with no errors.'
                    },
                    {
                        id: '5',
                        title: 'Deployment & Maintenance',
                        content: 'We coordinate flawless deployment and maintain continuous support, updates, and improvements to keep your software efficient and current.'
                    }
                ];
            case 'e-commerce-solutions-services':
                return [
                    {
                        id: '1',
                        title: 'Requirement Analysis',
                        content: 'We begin with a thorough review of your business requirements, target audiences, and merchandise. As the Best E-commerce Solutions Company in Alwar, we chart the proper platform, features, and design approach to address your objectives.'
                    },
                    {
                        id: '2',
                        title: 'UI/UX Design',
                        content: 'A good online shop must look good and work well. We create beautiful, responsive interfaces that are easy and fun to shop from.'
                    },
                    {
                        id: '3',
                        title: 'Custom E-commerce Development',
                        content: 'We create fully personalized e-commerce websites with features such as product filters, secure payment systems, inventory tracking, and order tracking.'
                    },
                    {
                        id: '4',
                        title: 'Testing & Quality Assurance',
                        content: 'We carry out thorough testing prior to launch to make your online store bug-free, secure, and performance-optimized.'
                    },
                    {
                        id: '5',
                        title: 'Deployment & Maintenance',
                        content: 'We help deploy stores, integrate with marketing platforms, and offer regular maintenance to maintain your e-commerce site\'s security and freshness.'
                    }
                ];
            case 'web-development-services':
                return [
                    {
                        id: '1',
                        title: 'Discovery Phase',
                        content: 'The discovery phase is where it all starts. In this phase, we learn about your business objectives, target market, and industry trends. Being the top web development agency in Alwar, we perform thorough research and competitor analysis to lay down a solid foundation. This enables us to determine the scope of the project, needs, and the correct strategy to have hassle-free development and strong results.'
                    },
                    {
                        id: '2',
                        title: 'Design and Development',
                        content: 'We place a strong emphasis on making the website incredibly user-friendly in addition to being aesthetically pleasing during the design and development stages. Together with our skilled staff, we use the most cutting-edge tools and frameworks to create cutting-edge, responsive, and effective websites. For professional website design in Alwar, we prioritize customized UI/UX design and scalable development along with SEO-friendly coding standards for improved rankings.'
                    },
                    {
                        id: '3',
                        title: 'Maintenance',
                        content: 'After your website goes live, maintenance is necessary on a regular basis. Our Alwar website maintenance services guarantee that your site remains current, secure, and free from bugs. Whether it\'s content updates and plugin updates or security updates, we do it all. With ongoing monitoring and optimization, we keep your site running efficiently with increased speed and performance.'
                    },
                    {
                        id: '4',
                        title: 'Deployment',
                        content: 'Deployment is the point at which your site actually goes live. Being a professional web development company in Alwar, we ensure the launch process is stress-free and without downtime. Right from domain setup and hosting to the last performance test, each step is observed carefully. We even offer complete post-deployment services so that your site keeps on running perfectly.'
                    },
                    {
                        id: '5',
                        title: 'Testing and QA',
                        content: 'Every website is put through a thorough testing and quality check process before being delivered in its final form. Our QA team checks every feature, including security, mobile support, and cross-browser compatibility, to ensure that it works perfectly. As one of the top web development company in Alwar, we guarantee a safe, high-performing, and bug-free website that meets your company goals.'
                    }
                ];
            default:
                return [
                    {
                        id: '1',
                        title: 'Discovery Phase',
                        content: 'Data - driven diagnostic and predictive app for improving outcomes Data driven diagnostic and predictive app for improving.'
                    },
                    {
                        id: '2',
                        title: 'Design and Development',
                        content: 'Data - driven diagnostic and predictive app for improving outcomes Data driven diagnostic and predictive app for improving.'
                    },
                    {
                        id: '3',
                        title: 'Maintenance',
                        content: 'Data - driven diagnostic and predictive app for improving outcomes Data driven diagnostic and predictive app for improving.'
                    },
                    {
                        id: '4',
                        title: 'Deployment',
                        content: 'Data - driven diagnostic and predictive app for improving outcomes Data driven diagnostic and predictive app for improving.'
                    },
                    {
                        id: '5',
                        title: 'Testing and QA',
                        content: 'Data - driven diagnostic and predictive app for improving outcomes Data driven diagnostic and predictive app for improving.'
                    }
                ];
        }
    };

    const contentItems = getContentBySlug();

    return (
        <section className="process_technology_review_section bg-light section_decoration">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="heading_block">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Working Process
                            </div>
                            <h2 className="heading_text mb-0">
                                Our <mark>Approach</mark>
                            </h2>
                        </div>
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            {contentItems.map((item) => (
                                <AccordionItem key={item.id} className="accordion-item">
                                    <AccordionHeader targetId={item.id}>
                                        {item.id}. {item.title}
                                    </AccordionHeader>
                                    <AccordionBody accordionId={item.id} className='acc_body'>
                                        <p className="m-0">
                                            {item.content}
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                    <div className="col-lg-5">
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            <ul className="content_layer_group unordered_list_block text-center">
                                {contentItems.map((item) => (
                                    <li key={item.id}>
                                        <AccordionHeader targetId={item.id}>
                                            <span>{item.title}</span>
                                        </AccordionHeader>
                                    </li>
                                ))}
                            </ul>
                        </Accordion>
                    </div>
                </div>
                <TechnologySection/>
                {/* <Testimonial/> */}
            </div>

            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="RashTech Shape" />
            </div>
        </section>
    )
};
export default FaqSection;
